import React, { useState, Fragment } from 'react'
import { useSelector } from 'react-redux'
import classnames from 'classnames'

import { Button, QuantityDisplay } from '@fielded/shared-ui'
import { Chevron, Edit, ExclamationTriangle } from '@fielded/shared-ui/src/icons'
import { getShipmentBatches } from '@fielded/fs-api/lib/shipment/utils/utils'

import { shipmentTitle } from '../../../../../common/utils'
import { selectProducts } from '../../../../../../../root/reducers/shipments/master-data'
import PickUpContentsTableItems from './PickUpContentsTableItems'

const PickUpContentsTable = ({
  shipments,
  history,
  isEditable,
  withAdjustmentsFeature
}) => {
  const products = useSelector(selectProducts)

  const [selectedShipment, setSelectedShipment] = useState()
  const colCount = 4

  const onSelectShipment = (event, shipment) => {
    event.stopPropagation()
    setSelectedShipment()

    if (selectedShipment && selectedShipment.id === shipment.id) {
      return
    }

    setSelectedShipment(shipment)
  }

  const onOpenAdjustment = (event, shipment) => {
    event.stopPropagation()
    history.push(`/shipments/pick-list/${shipment.snapshotId}`)
  }

  return (
    <div className='pick-up-contents'>
      <table className='pick-up-contents__main-table'>
        <thead>
          <tr>
            <th className='pick-up-contents__icon'>&nbsp;</th>
            <th
              className={classnames(
                'pick-up-contents__name',
                {'pick-up-contents__name--with-adjustments': withAdjustmentsFeature}
              )}
              colSpan={colCount}
            >
              Shipments</th>
            <th
              className={classnames(
                'pick-up-contents__quantity',
                {'pick-up-contents__quantity--with-adjustments': withAdjustmentsFeature}
              )}
            >
              No. of products
            </th>
            {withAdjustmentsFeature && (
              <th className='pick-up-contents__adjustment'>Adjusted no. of products</th>
            )}
          </tr>
        </thead>

        <tbody>
          {shipments.length ? shipments.map(shipment => {
            if (!shipment) return <Fragment /> // during the re-renders of the last step of driver to warehouse handover shipment is observed to be undefined crashing the UI
            const facilityName = shipmentTitle(shipment)
            const productCount = Object.keys(shipment.counts).length
            const isExpanded = selectedShipment && selectedShipment.id === shipment.id
            const batches = getShipmentBatches(shipment, products.byId)
            const isAdjusted = Object.values(shipment.counts).find(product => !!product.adjustment)

            return (
              <tr
                key={shipment.shipmentNo}
                className={classnames(
                  'pick-up-contents__main-table-row',
                  {'pick-up-contents__main-table-row--adjusted': isAdjusted && withAdjustmentsFeature}
                )}
                onClick={(event) => onSelectShipment(event, shipment)}
              >
                <td
                  className='pick-up-contents__icon'>
                  <Chevron direction={isExpanded ? 'up' : 'down'} />
                </td>
                <td
                  className={classnames(
                    'pick-up-contents__name',
                    {'pick-up-contents__name--with-adjustments': withAdjustmentsFeature}
                  )}
                  colSpan={colCount}
                >
                  {facilityName}
                </td>
                <td
                  className={classnames(
                    'pick-up-contents__quantity',
                    {'pick-up-contents__quantity--with-adjustments': withAdjustmentsFeature}
                  )}
                >
                  <QuantityDisplay value={productCount} />
                </td>
                {withAdjustmentsFeature && (
                  <td className='pick-up-contents__adjustment'>
                    <span className='vs-u-row vs-u-gap-half vs-u-align-baseline'>
                      <QuantityDisplay value={productCount} />
                      {isEditable && (
                        <Button
                          fill='none'
                          colorVariant='brand'
                          size='inline'
                          icon={<Edit />}
                          onClick={(event) => onOpenAdjustment(event, shipment)}
                        />
                      )}
                      {isAdjusted && (
                        <span
                          className='pick-up-contents__diff-icon'>
                          <ExclamationTriangle />
                        </span>
                      )}
                    </span>
                  </td>
                )}
                <td className='pick-up-contents__items'>
                  <PickUpContentsTableItems
                    isExpanded={isExpanded}
                    batches={batches}
                    withAdjustmentsFeature={withAdjustmentsFeature}
                  />
                </td>
              </tr>
            )
          }) : (
            <tr>
              <td colSpan={colCount}>
                There are no products in this delivery
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  )
}

export default PickUpContentsTable
